import styled from 'styled-components';

export const Container = styled.div`
  width: 140px;
  border-right: 1px solid #cccbcc;

  .logoContainer {
    text-align: center;
    padding: 30px 0;
  }

  a {
    all: unset;
    cursor: pointer;
  }
`;
